import { render, staticRenderFns } from "./tunnelDetailstwo.vue?vue&type=template&id=09d64182&scoped=true&"
import script from "./tunnelDetailstwo.vue?vue&type=script&lang=js&"
export * from "./tunnelDetailstwo.vue?vue&type=script&lang=js&"
import style0 from "./tunnelDetailstwo.vue?vue&type=style&index=0&id=09d64182&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d64182",
  null
  
)

export default component.exports